module.exports = __webpack_public_path__ + "static/media/05.8a272706.jpg";